import { Component, Input } from '@angular/core';

@Component({
  selector: 'content-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class ContentHeaderComponent {
  @Input() content?: any;

  constructor() {}
}
